import { render, staticRenderFns } from "./GradeRow.vue?vue&type=template&id=0752d11e&"
import script from "./GradeRow.vue?vue&type=script&lang=js&"
export * from "./GradeRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports